import { render } from "./UsersRegister.vue?vue&type=template&id=3e1e6d08"
import script from "./UsersRegister.vue?vue&type=script&lang=js"
export * from "./UsersRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__